@if (ready) {
  <yc-modal
    [simple]="true"
    [modalHeader]="modalHeader"
    [modalSubHeader]="userNameEmail"
    [primaryButtonText]="primaryButtonText"
    [cancelButtonText]="cancelButtonText"
    [primaryDisabled]="disablePrimaryButton"
    (onCancel)="onCancel()"
    (onPrimaryClick)="onPrimaryClick()">
    <div class="font-size-875">
      {{ modalBody }}
      @if (this.userAccessRemovedDate) {
        <span>
          <br><br>
          {{ modalBody_p_2 }}
          <br><br>
          {{ modalBody_p_3 }}
        </span>
      }
    </div>
    @if (confirmForm) {
      <div
        [formGroup]="confirmForm"
        class="mt-4">
        @if (npoOptions.length) {
          <div
            class="checkbox-container justify-content-center">
            <div class="flex-grow-1">
              <yc-checkbox-group
                name="selectNpos"
                [options]="npoDisplayOptions"
                [useInfiniteScroll]="true"
                [minHeightOfViewport]="'330px'"
                [maxHeightOfViewport]="'430px'"
                [showSelectAllOptions]="npoDisplayOptions.length > 1"
                (onChange)="getNposToRemove($event)">
              </yc-checkbox-group>
            </div>
          </div>
        }
        <yc-checkbox
          name="confirmNotSelecting"
          [optionLabel]="checkboxText"
          [centerLabel]="true">
        </yc-checkbox>
      </div>
    }
  </yc-modal>
}